<script lang="ts">
    import {
        END_CARD_BENEFIT_ONE,
        END_CARD_BENEFIT_THREE,
        END_CARD_BENEFIT_TWO,
        END_CARD_TEXT_TWO
    } from '../constants/imgList';
    import { isLogin } from '../store/index';

    import webp from '@/actions/webp';

    const benefits = [
        {
            bg: END_CARD_BENEFIT_ONE,
            title: 'Hasta 6%',
            tag: 'de CASHBACK*',
            description:
                'Se puede usar en diferentes categorías como entradas de cine, boletos de avión, farmacias, tiempo aire, etc.',
            align: 'left'
        },
        {
            bg: END_CARD_BENEFIT_TWO,
            title: 'Hasta 2%',
            tag: 'de CASHBACK*',
            description:
                'Se puede usar en supermercados, DiDi Food, tus viajes en DiDi, gasolina y más.',
            align: 'right'
        },
        {
            bg: END_CARD_BENEFIT_THREE,
            title: 'Comercios',
            tag: 'con MSI',
            description:
                'Se puede usar en comercios como Soriana, La Comer, VivaAerobus, Shein, Innova, entre otros.',
            align: 'left'
        }
    ];

</script>

<div class="card-end-benefit-new" class:card-end-benefit-new--logged={$isLogin}>
    {#if !$isLogin}
        <div
            class="benefit-title"
            use:webp={END_CARD_TEXT_TWO}
            role="img"
            aria-label="Beneficios"
        ></div>
    {/if}
    <div class="benefit-cards">
        {#each benefits as benefit, index (index)}
            <div
                class="benefit-card"
                class:benefit-card--align-right={benefit.align === 'right'}
            >
                <div class="benefit-card-bg" use:webp={benefit.bg}></div>
                <div class="benefit-card-text">
                    <span class="benefit-card-title">{benefit.title}</span>
                    <span class="benefit-card-tag">{benefit.tag}</span>
                    <p class="benefit-card-desc">{benefit.description}</p>
                </div>
            </div>
        {/each}
    </div>
</div>

<style lang="scss">
    .card-end-benefit-new {
        position: relative;
        z-index: 1;
        width: 100%;
        box-sizing: border-box;
        /* 距上方手机号模块 40px */
        margin-top: 0.4rem;
    }

    .card-end-benefit-new--logged {
        /* 与头部 title-img 间距 0.14rem */
        margin-top: 0.14rem;
    }

    .benefit-title {
        width: 100%;
        height: 1.2rem;
        margin: 0 auto;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
    }

    .benefit-cards {
        width: 100%;
        /* 距 Beneficios 标题图 14px */
        margin-top: 0.14rem;
        display: flex;
        flex-direction: column;
        /* benefit 卡片间距 20px */
        gap: 0.2rem;
        box-sizing: border-box;
    }

    .benefit-card {
        position: relative;
        /* 设计稿 686×320px */
        width: 6.86rem;
        height: 3.2rem;
        margin: 0 auto;
        border-radius: 0.32rem;
        overflow: hidden;
    }

    .benefit-card-bg {
        position: absolute;
        inset: 0;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center;
        pointer-events: none;
    }

    .benefit-card-text {
        position: relative;
        z-index: 1;
        box-sizing: border-box;
        width: 3.3rem;
        margin-left: 0.32rem;
        padding-top: 0.4rem;
        padding-bottom: 0.24rem;
        text-align: left;
    }

    .benefit-card--align-right .benefit-card-text {
        margin-left: auto;
        margin-right: 0.32rem;
    }

    .benefit-card-title,
    .benefit-card-tag {
        display: inline-block;
        font-family: DiDiSans-Pro-Bold;
        font-style: normal;
        font-weight: 700;
        letter-spacing: 0;
        background-image: linear-gradient(
            90deg,
            #ff4f00 -1.97%,
            #ffed00 51.63%,
            #00b274 96.69%
        );
        background-size: 100%;
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        color: transparent;
    }

    .benefit-card-title {
        font-size: 0.48rem;
        line-height: 0.64rem;
        text-align: center;
    }

    .benefit-card-tag {
        margin-top: 0.04rem;
        font-size: 0.28rem;
        line-height: 0.36rem;
    }

    @supports (color: color(display-p3 1 1 1)) {
        .benefit-card-title,
        .benefit-card-tag {
            background-image: linear-gradient(
                90deg,
                color(display-p3 1 0.3725 0.0784) -1.97%,
                color(display-p3 1 0.9333 0) 51.63%,
                color(display-p3 0.0902 0.6863 0.4745) 96.69%
            );
            background-clip: text;
            -webkit-background-clip: text;
        }
    }

    .benefit-card-desc {
        margin: 0.08rem 0 0;
        font-family: DiDiSans-Pro-Regular;
        font-size: 0.24rem;
        font-style: normal;
        font-weight: 400;
        line-height: 0.32rem;
        color: #ffffff;
    }

    @supports (color: color(display-p3 1 1 1)) {
        .benefit-card-desc {
            color: color(display-p3 1 1 1);
        }
    }
</style>
